import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ButtonLoading from 'components/ButtonLoading';

const JobActionsOption = ({
  className,
  assignedLabel,
  notAssignedLabel,
  onClick,
  loading,
  testId,
  pendingLabel
}) => {
  const { t } = useTranslation('PendingJobDetail');
  return (
    <div className={className} data-testid={'job-actions-option--' + testId}>
      <div className="job-actions-option">
        {!assignedLabel && (
          <div className="job-actions-option__pending-text">
            {notAssignedLabel}
          </div>
        )}
        {(assignedLabel || pendingLabel) && (
          <div className="job-actions-option__label-wrapper">
            {assignedLabel && (
              <div className="job-actions-option__assigned-text">
                {assignedLabel}
              </div>
            )}
            {pendingLabel && (
              <div className="job-actions-option__pending-vehicle">
                {pendingLabel}
              </div>
            )}
          </div>
        )}
        <ButtonLoading
          loading={loading}
          handleClick={e => {
            e.stopPropagation();
            onClick();
          }}
          testId={'job-actions-option--' + testId + '__btn'}
          className="job-actions-option__btn"
          text={assignedLabel ? t('edit') : t('assign')}
          nude
        />
      </div>
    </div>
  );
};

JobActionsOption.defaultProps = {
  className: '',
  assignedLabel: '',
  loading: false,
  pendingLabel: null
};

JobActionsOption.propTypes = {
  className: PropTypes.string,
  assignedLabel: PropTypes.string,
  notAssignedLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  testId: PropTypes.string,
  loading: PropTypes.bool,
  pendingLabel: PropTypes.string
};

export default JobActionsOption;
